import{V4LocalDbIndexed}from"./v4indexed/V4LocalDbIndexed";const v4localDbBuilder=()=>new V4LocalDbIndexed();export default v4localDbBuilder;